export default __webpack_public_path__ + "static/Pica team Servie-0de4c29e4d0318cfcdcd1eed6eda07ee.jpg";